<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full rounded-xl" v-if="serialModel != null">
                    <div v-if="serialModel.iimmpactVoucherlink == ''">
                        <SerialDetail :serialModel="serialModel"></SerialDetail>
                        <Serial :serialModel="serialModel" ref="serial"></Serial>
                        <SerialCode class="py-4" :serialModel="serialModel"></SerialCode>
                        <SerialTimer :serialModel="serialModel" @onSerialExpired="onSerialExpired()"></SerialTimer>
                    </div>
                    <div v-else>
                        <SerialDetail :serialModel="serialModel"></SerialDetail>
                        <!-- <PrivilegeMessage :serialModel="serialModel"></PrivilegeMessage> -->
                        <div class="text-center text-im-gray-767676 text-14">Thank you here is your redemption</div>
                        <SerialCode class="pt-4" :serialModel="serialModel"></SerialCode>
                        <div class="text-center px-4 py-8">
                            <button class="border bg-primary-color text-secondary-color rounded-full w-full text-20 font-bold py-2.5" @click="clickVoucherLink()">Get Your Rewards</button>
                        </div>
                    </div>
                    <div class="text-center py-3 border-t border-im-gray-e9e8e8">
                        <button class="text-im-gray-767676 text-20 font-bold underline" @click="clickClose()">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
//component
import SerialDetail from "./component/SerialDetail.vue";
import Serial from "./component/Serial.vue";
import SerialTimer from "./component/SerialTimer.vue";
import SerialCode from "./component/SerialCode.vue";
// import PrivilegeMessage from "./component/PrivilegeMessage.vue";

export default {
    name: "SerialModal",
    components: {
        SerialDetail,
        Serial,
        SerialTimer,
        SerialCode,
        // PrivilegeMessage
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,
            busModal: null,

            serialModel: null,
            serial: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function(config) {
            this.serialModel = config.serialModel;
            this.serial = JSON.parse(this.serialModel.serial);

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickClose: function() {
            this.hide();
            this.controller.sendCloseModal();
        },

        getRedeemMessage: function () {
            let dateStr = DatetimeHelper.getDatetimeFullFormat(this.serialModel.redeemTimestamp);
            return Util.stringFormat(this.lbl.serial.redeem_on, dateStr);
        },

        onSerialExpired: function() {
            this.$refs['serial'].setSerialExpire();
            this.controller.sendSerialExpire();
        },
        clickVoucherLink: function() {
            this.hide();
            console.log(this.serial.voucherlink)
            if (this.serial.voucherlink != '') {
                window.location.replace(this.serial.voucherlink)
            }
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "../../style/base/base.scss";
    @import "../../style/modal.scss";

    .modal {
        @extend %modal;

        .modal-content {
            overflow: unset;
        }
    }
</style>
